var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "popup popup-full popup-ord-dtl active",
      attrs: { id: "popup-ord-dtl" }
    },
    [
      _c("div", { attrs: { id: "wrap" } }, [
        _c("header", { staticClass: "replboxHead" }, [
          _vm._m(0),
          _c("h1", [_vm._v("주문/발송 상세")]),
          _c("div", { staticClass: "menu_side" }, [
            _c(
              "a",
              {
                staticClass: "btn_detail_close",
                on: {
                  click: function($event) {
                    return _vm.$go(-1)
                  }
                }
              },
              [_c("i", { staticClass: "xi-close" })]
            )
          ])
        ]),
        _c(
          "section",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.goodsList != undefined && _vm.goodsList.length > 0,
                expression: "goodsList!=undefined && goodsList.length > 0"
              }
            ],
            staticClass: "order_detail"
          },
          [
            _c(
              "div",
              { staticClass: "order_detail_wrap", attrs: { id: "top" } },
              [
                _c("h5", { staticClass: "payment_status" }, [
                  _vm._v(_vm._s(_vm.ord.dlv))
                ]),
                _c("dl", { staticClass: "payment_result" }, [
                  _c("dt", [_vm._v("주문번호")]),
                  _c("dd", [_vm._v(_vm._s(this.odOrdMst.ord_no))])
                ]),
                _c("dl", { staticClass: "payment_result" }, [
                  _c("dt", [_vm._v("주문일")]),
                  _c("dd", [_vm._v(_vm._s(_vm.ord.ord_dtime))])
                ])
              ]
            ),
            _c("div", { staticClass: "order_detail_wrap" }, [
              _c(
                "ul",
                { staticClass: "inquiry product_payment_list" },
                _vm._l(_vm.goodsList, function(good) {
                  return _c("li", { key: good.good_no }, [
                    _c("div", { staticClass: "thumb" }, [
                      _c("img", {
                        attrs: {
                          src:
                            _vm.$store.getters["systemStore/getImgPath"] +
                            good.good_img_url,
                          alt: good.good_nm
                        }
                      })
                    ]),
                    _c("div", { staticClass: "info" }, [
                      _c("p", { staticClass: "product_name" }, [
                        _vm._v(_vm._s(good.good_nm))
                      ]),
                      _c("strong", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(good.sale_price.toLocaleString()) +
                            "원 X " +
                            _vm._s(good.real_ord_qty) +
                            "개"
                        )
                      ])
                    ])
                  ])
                }),
                0
              )
            ]),
            _c("div", { staticClass: "order_detail_wrap" }, [
              _c("h5", [_vm._v("주문자 정보")]),
              _c("dl", { staticClass: "payment_result" }, [
                _c("dt", [_vm._v("주문자")]),
                _vm._v(" "),
                _c("dd", [_vm._v(_vm._s(_vm.odOrdMst.orderer_nm))])
              ]),
              _c("dl", { staticClass: "payment_result" }, [
                _c("dt", [_vm._v("휴대폰 번호")]),
                _vm._v(" "),
                _c("dd", [
                  _vm._v(
                    _vm._s(_vm.odOrdMst.cell_no_1) +
                      "-" +
                      _vm._s(_vm.odOrdMst.cell_no_2) +
                      "-" +
                      _vm._s(_vm.odOrdMst.cell_no_3)
                  )
                ])
              ]),
              _c("dl", { staticClass: "payment_result" }, [
                _c("dt", { staticStyle: { width: "auto" } }, [
                  _vm._v("이메일")
                ]),
                _vm._v(" "),
                _c("dd", { staticStyle: { width: "auto" } }, [
                  _vm._v(_vm._s(_vm.odOrdMst.email))
                ])
              ])
            ]),
            _c("div", { staticClass: "order_detail_wrap" }, [
              _c("h5", [_vm._v("결제 정보")]),
              _c("dl", { staticClass: "payment_result" }, [
                _c("dt", [_vm._v("결제 방법")]),
                _vm._v(" "),
                _c("dd", [_vm._v(_vm._s(_vm.pay_mean))])
              ]),
              _vm.odOrdMst.ord_no === "202112210989319" ||
              _vm.odOrdMst.ord_no === "202112210984031" ||
              _vm.odOrdMst.ord_no === "202112200978777" ||
              _vm.odOrdMst.ord_no === "202112200970529" ||
              _vm.odOrdMst.ord_no === "202112200967802" ||
              _vm.odOrdMst.ord_no === "202112170936682" ||
              _vm.odOrdMst.ord_no === "202112170941106" ||
              _vm.odOrdMst.ord_no === "202112200965776" ||
              _vm.odOrdMst.ord_no === "202112200966743"
                ? _c("dl", { staticClass: "payment_result final" }, [
                    _c("dt", [_vm._v("최초결제금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [
                        _vm._v(
                          _vm._s(_vm.cost.FIRST_TOTAL_AMT.toLocaleString()) +
                            "원"
                        )
                      ]
                    ),
                    _c("dt", [_vm._v("환불(부분취소)금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [_vm._v(_vm._s(_vm.cost.RE_AMT.toLocaleString()) + "원")]
                    ),
                    _c("dt", [_vm._v("총 할인금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [_vm._v("6,000원")]
                    ),
                    _c("dt", [_vm._v("총 결제금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [_vm._v("0원")]
                    )
                  ])
                : _vm.odOrdMst.ord_no === "202112200968077" ||
                  _vm.odOrdMst.ord_no === "202112170931027"
                ? _c("dl", { staticClass: "payment_result final" }, [
                    _c("dt", [_vm._v("최초결제금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [
                        _vm._v(
                          _vm._s(_vm.cost.FIRST_TOTAL_AMT.toLocaleString()) +
                            "원"
                        )
                      ]
                    ),
                    _c("dt", [_vm._v("총 할인금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [_vm._v("6,000원")]
                    ),
                    _c("dt", [_vm._v("총 결제금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [_vm._v("6,000원")]
                    )
                  ])
                : _vm.odOrdMst.ord_no === "202112170939564"
                ? _c("dl", { staticClass: "payment_result final" }, [
                    _c("dt", [_vm._v("최초결제금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [
                        _vm._v(
                          _vm._s(_vm.cost.FIRST_TOTAL_AMT.toLocaleString()) +
                            "원"
                        )
                      ]
                    ),
                    _c("dt", [_vm._v("총 할인금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [_vm._v("67,000원")]
                    ),
                    _c("dt", [_vm._v("총 결제금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [_vm._v("335,000원")]
                    )
                  ])
                : _vm.odOrdMst.ord_no === "202112200967916"
                ? _c("dl", { staticClass: "payment_result final" }, [
                    _c("dt", [_vm._v("최초결제금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [
                        _vm._v(
                          _vm._s(_vm.cost.FIRST_TOTAL_AMT.toLocaleString()) +
                            "원"
                        )
                      ]
                    ),
                    _c("dt", [_vm._v("총 할인금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [_vm._v("15,000원")]
                    ),
                    _c("dt", [_vm._v("총 결제금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [_vm._v("120,000원")]
                    )
                  ])
                : _c("dl", { staticClass: "payment_result final" }, [
                    _c("dt", [_vm._v("최초결제금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [
                        _vm._v(
                          _vm._s(_vm.cost.FIRST_TOTAL_AMT.toLocaleString()) +
                            "원"
                        )
                      ]
                    ),
                    _c("dt", [_vm._v("환불(부분취소)금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [_vm._v(_vm._s(_vm.cost.RE_AMT.toLocaleString()) + "원")]
                    ),
                    _c("dt", [_vm._v("총 결제금액")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { class: { cancel: _vm.ord.dlv === "결제취소" } },
                      [
                        _vm._v(
                          _vm._s(_vm.cost.GOOD_TOTAL_AMT.toLocaleString()) +
                            "원"
                        )
                      ]
                    )
                  ])
            ]),
            _vm.deposit
              ? _c("div", { staticClass: "order_detail_wrap" }, [
                  _c("h5", [_vm._v("무통장 상세 정보")]),
                  _c("dl", { staticClass: "payment_result" }, [
                    _c("dt", [_vm._v("입금 계좌번호")]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm._v(
                        " " +
                          _vm._s(this.bank_cd) +
                          " " +
                          _vm._s(this.account_no) +
                          " "
                      )
                    ])
                  ]),
                  _vm._m(1),
                  _c("dl", { staticClass: "payment_result" }, [
                    _c("dt", [_vm._v("입금인")]),
                    _vm._v(" "),
                    _c("dd", [_vm._v(" " + _vm._s(this.morc_nm) + " ")])
                  ]),
                  _c("dl", { staticClass: "payment_result" }, [
                    _c("dt", [_vm._v("입금금액")]),
                    _vm._v(" "),
                    _c("dd", [_vm._v(" " + _vm._s(this.pay_amt) + "원 ")])
                  ]),
                  _c("dl", { staticClass: "payment_result" }, [
                    _c("dt", [_vm._v("입금기한")]),
                    _vm._v(" "),
                    _c("dd", [_vm._v(" " + _vm._s(this.expiry_date) + " ")])
                  ])
                ])
              : _vm._e(),
            _vm.ord.dlv === "상품준비중" ||
            (_vm.ord.dlv != "결제취소" &&
              _vm.giftishow_yn === "Y" &&
              _vm.giftishow_cancel_poss_yn === "Y")
              ? _c("div", { staticClass: "order_detail_wrap" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn_large",
                      on: {
                        click: function($event) {
                          return _vm.allCancle()
                        }
                      }
                    },
                    [_vm._v("전체주문취소")]
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "order_detail_wrap txt-center" }, [
              _c("p", { staticClass: "support" }, [
                _vm._v("고객지원 "),
                _c("strong", { staticClass: "txt_blue" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "tel:" + _vm.$store.getters["systemStore/getTel"]
                      }
                    },
                    [_vm._v(_vm._s(_vm.$store.getters["systemStore/getTel"]))]
                  )
                ])
              ]),
              _vm._m(2)
            ]),
            _c("Footer")
          ],
          1
        )
      ]),
      _c("div", { staticClass: "popup ord_dtl_01" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _vm._m(3),
          _c("div", { staticClass: "popup_button" }, [
            _c(
              "button",
              {
                staticClass: "btn_large",
                on: {
                  click: function($event) {
                    return _vm.$go(-1)
                  }
                }
              },
              [_vm._v("확 인")]
            )
          ])
        ]),
        _c("div", { staticClass: "dimBg" })
      ]),
      _c("div", { staticClass: "popup ord_dtl_02" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _c("div", { staticClass: "popup_content" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })
          ]),
          _vm._m(4)
        ]),
        _c("div", { staticClass: "dimBg" })
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn_back hidden" }, [
      _c("a", { staticClass: "button" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "payment_result" }, [
      _c("dt", [_vm._v("예금주")]),
      _vm._v(" "),
      _c("dd", [_vm._v(" 삼성웰스토리㈜ ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "use_time" }, [
      _c("span", [_vm._v("평일 09:00 - 18:00")]),
      _c("br"),
      _c("span", [_vm._v("주말 및 공휴일 휴무")]),
      _c("br"),
      _c("span", [_vm._v("점심시간 12:00 - 13:00")]),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content" }, [
      _c("p", [_vm._v("주문이 취소되었습니다.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_button" }, [
      _c(
        "button",
        { staticClass: "btn_large", attrs: { onclick: "modal('ord_dtl_02')" } },
        [_vm._v("확 인")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }